import { Amplify } from 'aws-amplify';
import { generateClient } from 'aws-amplify/api';
import config from './amplifyconfiguration.json';
import { createVote } from "./graphql/mutations";

Amplify.configure(config);
const client = generateClient();

const MAX_VOTES = 4;

document.querySelectorAll(".vote").forEach((item) => {
  console.log("add listener");
  item.addEventListener("click", sendVote);
});

function getVoteCount() {
  const cookie = document.cookie
    .split("; ")
    .find((row) => row.startsWith("sbgcvotecount26="));
  return cookie ? parseInt(cookie.split("=")[1], 10) : 0;
}

function setVoteCount(count) {
  document.cookie =
    "sbgcvotecount26=" + count + "; expires=Sun, 12 Feb 2026 23:59:59 GMT; Secure";
}

function getLastVote() {
  const cookie = document.cookie
    .split("; ")
    .find((row) => row.startsWith("sbgcvote26="));
  return cookie ? cookie.split("=")[1] : null;
}

function setLastVote(votedFor) {
  document.cookie =
    "sbgcvote26=" + votedFor + "; expires=Sun, 12 Feb 2026 23:59:59 GMT; Secure";
}

async function sendVote(e) {
  var votedFor = e.target.dataset.ad;
  var currentCount = getVoteCount();

  if (currentCount >= MAX_VOTES) {
    return; // Already at max votes
  }

  document.getElementById("options").classList.remove("novote");
  document.getElementById("options").classList.add("done");
  document.getElementById("instructions").innerText = "Processing your vote...";

  try {
    gtag('event', votedFor);

    const newVote = await client.graphql({
      query: createVote,
      variables: {
        input: {
          vote: votedFor,
        }
      }
    });

    console.log(newVote);
    
    currentCount++;
    setVoteCount(currentCount);
    setLastVote(votedFor);
    
    document.getElementById(votedFor).classList.add("yes");
    document.getElementById("instructions").innerText = "Thanks for voting!";
  } catch (err) {
    console.error(err);
    
    currentCount++;
    setVoteCount(currentCount);
    setLastVote(votedFor);
    
    document.getElementById(votedFor).classList.add("yes");
    document.getElementById("instructions").innerText = "Thanks for voting!";
  }
}

function init() {
  console.log("run init");
  
  var currentCount = getVoteCount();
  
  //OPEN FOR VOTE
  /*
  if (currentCount >= MAX_VOTES) {
    // User has used all votes
    var lastVote = getLastVote();
    document.getElementById("options").classList.add("done");
    if (lastVote) {
      document.getElementById(lastVote).classList.add("yes");
    }
    document.getElementById("instructions").innerText = "Thanks for voting!";
  } else {
    // User can still vote
    document.getElementById("options").classList.add("novote");
    document.getElementById("instructions").innerText =
      "Vote for your favorite!";
  }
  */
  //END OPEN VOTE
  
  document.getElementById("termsLink").onclick = function () {
    document.getElementById("terms").classList.toggle("show");
  };

  //VOTE CLOSED
    document.getElementById("options").classList.add("done");
    document.getElementById("bud26").classList.add("yes");
    document.getElementById("instructions").innerText = "Voting is closed. See you next year!";
  
}

window.onload = function () {
  init();
};